import { forwardRef, useImperativeHandle } from "react";
import { InputAdornment, TextField } from "@mui/material";
import Cleave from "cleave.js/react";

const CurrencyInput = forwardRef((props, ref) => {
  const { maxDecimals, ...restProps } = props;

  useImperativeHandle(ref, () => ({
    focus: () => {},
  }));

  const cleaveOptions = {
    numeral: true,
    rawValueTrimPrefix: true,
    numeralDecimalScale: maxDecimals || 2,
  };

  return (
    <Cleave options={cleaveOptions} {...restProps} />
  );
});

const CurrencyField = (props) => {
  const { maxDecimals, ...restProps } = props;

  return (
    <TextField
      disabled={restProps.disabled}
      InputProps={{
        inputComponent: CurrencyInput,
        inputProps: { maxDecimals },
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      {...restProps}
    />
  );
};

export default CurrencyField;
